<template>
  <div id="overlay">
    <b-spinner label="Loading..."></b-spinner>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  inheritAttrs: true,
  props: {
    spinnerProps: Object,
    overlayProps: Object,
    percentage: Number,
  },
  data() {
    return {
      absolute: true,
      opacity: 0.3,
      overlay: false,
      percent: '',
      defaultProps: {
        spinnerProps: {
          color: 'primary',
          value: 100,
          indeterminate: true,
          size: 80,
        },
        overlayProps: {},
      },
      options: {
        spinnerProps: {},
        overlayProps: {},
      },
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    loadingPercent() {
      return this.$store.state.loadingPercent;
    },
  },
  watch: {
    isLoading(newValue, oldValue) {
      // Our fancy notification (2).
      this.overlay = newValue;
      // console.log(`loading ${newValue}`)
    },
    loadingPercent(newValue, oldValue) {
      if (typeof newValue === 'number') {
        this.percent = Math.floor(newValue > 1 ? newValue : newValue * 100) + '%';
      } else {
        this.percent = newValue;
      }
    },
  },
  mounted() {
    this.mergeProps();
  },
  methods: {
    show() {
      this.overlay = true;
    },
    hide() {
      this.overlay = false;
    },
    mergeProps() {
      // merge snipper props
      this.options.spinnerProps = {
        ...this.defaultProps.spinnerProps,
        ...this.$props.spinnerProps,
      };

      // merge overlay props
      this.options.overlayProps = {
        ...this.defaultProps.overlayProps,
        ...this.$props.overlayProps,
      };
      // console.log(this.options);
    },
  },
};
</script>

<style scoped>
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}


.stat-circle circle.bg {
  fill: none;
  stroke: #f1f1f1;
  stroke-width: 2;
}

.stat-circle circle.progress {
  fill: none;
  stroke: #F39800;
  stroke-width: 2;
  stroke-dasharray: 51 51;
  stroke-dashoffset: -51;
  stroke-linecap: round;
}

.stat-circle text {
  font-size: 3px;
  text-anchor: middle;
  fill: #555;
}


</style>
